export const GET_DASHBOARD = 'GIFTYA/GET_DASHBOARD';
export const GET_DASHBOARD_RESET = 'GIFTYA/GET_DASHBOARD_RESET';
export const GET_MERCHANT_DETAILS = 'GIFTYA/GET_MERCHANT_DETAILS';
export const GET_MERCHANT_DETAILS_RESET = 'GIFTYA/GET_MERCHANT_DETAILS_RESET';
export const GET_MERCHANT_LOCATIONS = 'GIFTYA/GET_MERCHANT_LOCATIONS';
export const GET_MERCHANT_LOCATIONS_RESET = 'GIFTYA/GET_MERCHANT_LOCATIONS_RESET';
export const GET_MERCHANT_REPORT = 'GIFTYA/GET_MERCHANT_REPORT';
export const GET_MERCHANT_REPORT_RESET = 'GIFTYA/GET_MERCHANT_REPORT_RESET';
export const GET_ACCOUNT_DATA = 'GIFTYA/GET_ACCOUNT_DATA';
export const GET_ACCOUNT_DATA_RESET = 'GIFTYA/GET_ACCOUNT_DATA_RESET';
export const GET_ACCOUNT_USERS = 'GIFTYA/GET_ACCOUNT_USERS';
export const GET_ACCOUNT_USERS_RESET = 'GIFTYA/GET_ACCOUNT_USERS_RESET';
export const GET_USER_ACCOUNT = 'GIFTYA/GET_USER_ACCOUNT';
export const GET_USER_ACCOUNT_RESET = 'GIFTYA/GET_USER_ACCOUNT_RESET';
export const ADD_USER_ACCOUNT = 'GIFTYA/ADD_USER_ACCOUNT';
export const ADD_USER_ACCOUNT_RESET = 'GIFTYA/ADD_USER_ACCOUNT_RESET';
export const UPDATE_USER_ACCOUNT = 'GIFTYA/UPDATE_USER_ACCOUNT';
export const UPDATE_USER_ACCOUNT_RESET = 'GIFTYA/UPDATE_USER_ACCOUNT_RESET';
export const UPDATE_ACCOUNT_DATA = 'GIFTYA/UPDATE_ACCOUNT_DATA';
export const UPDATE_ACCOUNT_DATA_RESET = 'GIFTYA/UPDATE_ACCOUNT_DATA_RESET';
export const SET_ACTIVE_CONCEPT_ID = 'GIFTYA/SET_ACTIVE_CONCEPT_ID';
export const SET_SELECTED_INDEX = 'GIFTYA/SET_SELECTED_INDEX';
export const GET_TOTAL_LOCATIONS_COUNT = 'GIFTYA/GET_TOTAL_LOCATIONS_COUNT';
export const GET_TOTAL_LOCATIONS_COUNT_RESET = 'GIFTYA/GET_TOTAL_LOCATIONS_COUNT_RESET';

export const getDashboard = (payload, meta = {}, error = false) => ({
    type: GET_DASHBOARD,
    payload,
    meta,
    error
});
export const getDashboardReset = (payload, meta, error) => ({
    type: GET_DASHBOARD_RESET,
    payload,
    meta,
    error
});
export const getMerchantDetails = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_DETAILS,
    payload,
    meta,
    error
});
export const getMerchantDetailsReset = (payload, meta, error) => ({
    type: GET_MERCHANT_DETAILS_RESET,
    payload,
    meta,
    error
});
export const getMerchantLocations = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_LOCATIONS,
    payload,
    meta,
    error
});
export const getMerchantLocationsReset = (payload, meta, error) => ({
    type: GET_MERCHANT_LOCATIONS_RESET,
    payload,
    meta,
    error
});
export const getMerchantReport = (payload, meta = {}, error = false) => ({
    type: GET_MERCHANT_REPORT,
    payload,
    meta,
    error
});
export const getMerchantReportReset = (payload, meta, error) => ({
    type: GET_MERCHANT_REPORT_RESET,
    payload,
    meta,
    error
});
export const getAccountData = (payload, meta = {}, error = false) => ({
    type: GET_ACCOUNT_DATA,
    payload,
    meta,
    error
});
export const getAccountDataReset = (payload, meta, error) => ({
    type: GET_ACCOUNT_DATA_RESET,
    payload,
    meta,
    error
});
export const getAccountUsers = (payload, meta = {}, error = false) => ({
    type: GET_ACCOUNT_USERS,
    payload,
    meta,
    error
});
export const getAccountUsersReset = (payload, meta, error) => ({
    type: GET_ACCOUNT_USERS_RESET,
    payload,
    meta,
    error
});
export const getUserAccount = (payload, meta = {}, error = false) => ({
    type: GET_USER_ACCOUNT,
    payload,
    meta,
    error
});
export const getUserAccountReset = (payload, meta, error) => ({
    type: GET_USER_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const addUserAccount = (payload, meta = {}, error = false) => ({
    type: ADD_USER_ACCOUNT,
    payload,
    meta,
    error
});
export const addUserAccountReset = (payload, meta, error) => ({
    type: ADD_USER_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const updateUserAccount = (payload, meta = {}, error = false) => ({
    type: UPDATE_USER_ACCOUNT,
    payload,
    meta,
    error
});
export const updateUserAccountReset = (payload, meta, error) => ({
    type: UPDATE_USER_ACCOUNT_RESET,
    payload,
    meta,
    error
});
export const updateAccountData = (payload, meta = {}, error = false) => ({
    type: UPDATE_ACCOUNT_DATA,
    payload,
    meta,
    error
});
export const updateAccountDataReset = (payload, meta, error) => ({
    type: UPDATE_ACCOUNT_DATA_RESET,
    payload,
    meta,
    error
});
export const setActiveConceptId = (payload, meta = {}, error = false) => ({
    type: SET_ACTIVE_CONCEPT_ID,
    payload,
    meta,
    error
});
export const setSelectedIndex = (payload, meta = {}, error = false) => ({
    type: SET_SELECTED_INDEX,
    payload,
    meta,
    error
});
export const getTotalLocationsCount = (payload, meta = {}, error = false) => ({
    type: GET_TOTAL_LOCATIONS_COUNT,
    payload,
    meta,
    error
});
export const getTotalLocationsCountReset = (payload, meta = {}, error = false) => ({
    type: GET_TOTAL_LOCATIONS_COUNT_RESET,
    payload,
    meta,
    error
});